import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["output"]

  connect() {
  }

  checkProduct() {
    if (this.product_status == `going`) {
      return true
    } else {
      this.doModalHtml()
    }
  }
  
   


  doModalHtml() {
    var html = `<div class="modal fade" data-controller="app--communications--connection--modal" data-app--communications--connection--modal-target="modal" id="patientModal" tabindex="-1" role="dialog" aria-labelledby="patientModalTitle" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div class="modal-content">
                      <div class="modal-header border-bottom py-0">
                        <h6 class="modal-title py-2 mx-auto"><strong class="f-075">Sem conexão</strong></h6><br>
                      </div>
                      <div class="modal-body p-3" data-app--communications--connection--modal-target="body">
                        <div class="row my-2">
                          <div class="col-12 text-center">
                            <span class="f-075">Verifique a sua conexão!!</span>
                          </div>
                        </div>
                        <div class="row my-2">
                          <div class="col-12 text-center">
                            <span class="material-icons md-dark md-lg">portable_wifi_off</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>`
    var controller = this
    new Promise(function (resolve) {
      resolve(document.body.insertAdjacentHTML("beforeend", html))
    }).then(() => {
      // controller.open()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

}